import { TextSize, Weight } from 'components'

import { GLOBAL_COLORS } from 'theme'
import styled from 'styled-components'

interface TabButton {
  active: boolean
}

export const TabWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  ${({ theme }) => theme.mediaWidth.Tablet`
    margin: 0 20px;
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin: 0 20px;
  `}
`

export const TabButtonWrapper = styled.div<TabButton>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 61px;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  font-size: ${TextSize.nav};
  font-weight: ${Weight.Bold};
  width: 50%;
  ${({ theme }) => `color: ${theme.text1};`}
  ${({ active }) =>
    active
      ? `border-bottom: 5px solid ${GLOBAL_COLORS.tidalBlue};`
      : `border-bottom: 5px solid transparent;`}
`
